
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazinok",
      function () {
        return require("private-next-pages/magazinok.tsx");
      }
    ]);
  